import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Main from '@/components/main'
import Describe from '@/components/describe'
import About from '@/components/about'
import Environment from '@/components/environment'
import Setmeal from '@/components/setmeal'
import Praise from '@/components/praise'
import Inform from '@/components/inform'
import Story from '@/components/aboutStory'
import Team from '@/components/aboutTeam'
import Us from '@/components/aboutUs'
import Advantage from '@/components/advantage'
import Dynamic from '@/components/dynamic'
import DynamicDetail from '@/components/dynamicDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children:[
        {path:'/',name:'main', component: Main},
        {path:'/describe',name:'describe', component: Describe},
        {path:'/about',name:'about', component: About},
        {path:'/environment',name:'environment', component:Environment},
        {path:'/setmeal',name:'setmeal', component:Setmeal},
        {path:'/praise',name:'praise', component:Praise},
        {path:'/inform',name:'inform', component:Inform},
        {path:'/about/story',name:'story', component:Story},
        {path:'/about/team',name:'aboutTeam', component:Team},
        {path:'/about/us',name:'aboutUs', component:Us},
        {path:'/advantage',name:'advantage', component:Advantage},
        {path:'/dynamic',name:'dynamic', component:Dynamic},
        {path:'/dynamicDetail/:id',name:'dynamic-deatil', component:DynamicDetail},
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js